import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/casos-de-exito/agile-validation-support-for-a-global-life-sciences-organization")({
  head: () => buildRouteHead("/es/casos-de-exito/agile-validation-support-for-a-global-life-sciences-organization", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/casos-de-exito/soporte-de-validacion-agil-para-una-organizacion-global-de-ciencias-de-la-vida", replace: true });
  },
});
